import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import LeagueTournamentDialog from "src/components/pickem-admin/LeagueTournamentDialog";
// ----------------------------------------------------------------------

export default function LeagueTournamentsPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState(null);
  const [openTournamentDialog, setOpenTournamentDialog] = useState(false);
  const [editTournament, setEditTournament] = useState(null);
  const [leagueId, setLeagueId] = useState(null);
  const [openPopover, setOpenPopover] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (searchParams.has("league_id")) {
      let id = searchParams.get("league_id");
      setLeagueId(id);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${id}/tournaments`
        )
        .then(function (response) {
          setRows(response.data.tournaments);
        });
    }
  }, []);

  const successTournamentHandler = (tournament) => {
    console.log("successTournamentHandler", tournament);
    if (tournament?.league_tournament_id) {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${leagueId}/tournaments/${tournament.league_tournament_id}`,
          tournament
        )
        .then(function (response) {
          window.location.reload(false);
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${leagueId}/tournaments`,
          tournament
        )
        .then(function (response) {
          window.location.reload(false);
        });
    }
  };
  const deleteTournamentHandler = (optionIndex) => {
    /*
    let option = question.options[optionIndex];
    if (option?.option_id) {
      axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-options/${pickemId}?option_id=${option.option_id}`
        )
        .then(function (response) {
          question.options.splice(optionIndex, 1);
          setQuestion({ ...question });
        });
    } else {
      question.options.splice(optionIndex, 1);
      setQuestion({ ...question });
    }
    */
  };
  const editTournamentHandler = (tournamentId) => {
    const editTournament = rows.find(
      (row) => row.league_tournament_id == tournamentId
    );
    setEditTournament(editTournament);
    setOpenTournamentDialog(true);
  };
  const closeTournamentDialog = () => {
    setEditTournament(null);
    setOpenTournamentDialog(false);
  };
  const openAddTournamentDialog = () => {
    setEditTournament(null);
    setOpenTournamentDialog(true);
  };
  const handleOpenMenu = (event) => {
    setOpenPopover(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpenPopover(null);
    setOpenId(null);
  };
  return (
    <>
      <Helmet>
        <title>League Tournaments</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            League Tournaments
          </Typography>
          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:close-outline" />}
              onClick={() => navigate(`/dashboard/leagues`)}
              sx={{ mr: 2 }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => openAddTournamentDialog()}
            >
              Create Tournament
            </Button>
          </Box>
        </Stack>

        <Card>
          {rows === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Visible</TableCell>
                      <TableCell>Title</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Start</TableCell>
                      <TableCell>End</TableCell>
                      <TableCell>Prize Image</TableCell>
                      <TableCell>Prize Image Fr</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.league_tournament_id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.is_visible ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.title}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.tournament_type}
                        </TableCell>
                        <TableCell> {row.start_time}</TableCell>
                        <TableCell> {row.end_time}</TableCell>
                        <TableCell>
                          <img style={{ width: 100 }} src={row.prize_image} />
                        </TableCell>
                        <TableCell>
                          <img
                            style={{ width: 100 }}
                            src={row.prize_image_fr}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.league_tournament_id}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <Popover
        open={Boolean(openPopover)}
        anchorEl={openPopover}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() =>
            navigate(
              `/dashboard/leaderboards/view?league_id=${leagueId}&tournament_id=${openId}`
            )
          }
        >
          <Iconify icon={"eva:list-outline"} sx={{ mr: 1 }} />
          Leaderboard
        </MenuItem>

        <MenuItem onClick={() => editTournamentHandler(openId)}>
          <Iconify icon={"eva:edit-outline"} sx={{ mr: 1 }} />
          Edit
        </MenuItem>
      </Popover>
      <LeagueTournamentDialog
        tournament={editTournament}
        open={openTournamentDialog}
        onSuccessHandler={successTournamentHandler}
        onClose={closeTournamentDialog}
      />
    </>
  );
}
